import { Injectable } from '@angular/core';
import { TranslateService } from '__services';
import { SweetAlertOptions } from 'sweetalert2';
import { Constants } from '../configs/constants';
import { timer } from 'rxjs/dist/types';

declare var swal: any;
@Injectable({
  providedIn: 'root'
})
export class SwalService {

  static instance: SwalService = null;  // Create a singleton service

  constructor(
    private translationService: TranslateService
  ) {
    return SwalService.instance = SwalService.instance || this;
  }

  public static warning(message: string) {
    return swal.fire({
      text: message,
      icon: 'warning', // 8.x uses 'type', 9.x uses 'icon'
      confirmButtonText: 'OK',
    });
  }

  public static error(message) {
    return swal.fire({
      text: message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
  public static success(message) {
    // const Toast = swal.mixin({
    //   toast: true,
    //   position: 'top',
    //   showConfirmButton: false,
    //   timer: 3000,
    // });

    // return Toast.fire({
    //   icon: 'success',
    //   title: message
    // });
    return swal.fire({
      icon: 'success',
      position: 'center',
      title: message,
      showConfirmButton: false,
      timer: 2000
    });

  }

  public static errorWithHtml(config: any = {}) {
    return swal.fire({
      icon: 'error',
      position: 'center',
      title: config.title || 'Error',
      html: config.html || '',
      confirmButtonText: 'OK',
      showConfirmButton: config.showConfirmButton ?? false,
      timer: config.timer ?? 5000
    });
  }

  public static close() {
    swal.close();
  }

  public static customSwal(config: any = {}, customClass = {}, callback?: Function) {
    const option: SweetAlertOptions = {
      title: config.title || '',
      text: config.message || '',
      html: config.html || '',
      padding: 0,
      confirmButtonText: config.confirmText || 'OK',
      cancelButtonText: config.cancelText || 'CANCEL',
      customClass,
      icon: config.icon || null,
      input: config.input || '',
      inputPlaceholder: config.inputPlaceholder || '',
      imageUrl: config.imageUrl || '',
      imageWidth: config.imageWidth || '',
      imageHeight: config.imageHeight || '',
      imageAlt: config.imageAlt || '',
      timer: config.timer || null,
      preConfirm: config.preConfirm || null,
      inputValidator: config.inputValidator || null,
      buttonsStyling: config.buttonsStyling !== undefined ? config.buttonsStyling : false,
      allowOutsideClick: config.allowOutsideClick !== undefined ? config.allowOutsideClick : true,
      showCancelButton: config.showCancelButton !== undefined ? config.showCancelButton : false,
      showConfirmButton: config.showConfirmButton !== undefined ? config.showConfirmButton : false,
      showCloseButton: config.allowOutsideClick !== undefined ? config.showCloseButton : false,
      reverseButtons: config.reverseButtons !== undefined ? config.reverseButtons : false
    };
    swal.fire(option).then(result => {
      if (callback) {
        callback(result);
      }
    });
  }

  public static defaultCustomSwal(options: any = {}, customClass = {}, callback?: Function) {
    swal.fire(options).then(result => {
      if (callback) {
        callback(result);
      }
    });
  }

  async yesNoSwal(message: string): Promise<any> {
    const config: any = Constants.getConfirmConfig(
      `${message}`,
      this.translationService.translate('Yes'),
      this.translationService.translate('No')
    );
    const option: SweetAlertOptions = {
        title: config.title || '',
        text: config.message || '',
        html: config.html || '',
        padding: 0,
        confirmButtonText: config.confirmText,
        cancelButtonText: config.cancelText,
        customClass: Constants.AlertCommonStyle,
        icon: config.icon || null,
        input: config.input || '',
        inputPlaceholder: config.inputPlaceholder || '',
        imageUrl: config.imageUrl || '',
        imageWidth: config.imageWidth || '',
        imageHeight: config.imageHeight || '',
        imageAlt: config.imageAlt || '',
        timer: config.timer || null,
        preConfirm: config.preConfirm || null,
        inputValidator: config.inputValidator || null,
        buttonsStyling: config.buttonsStyling !== undefined ? config.buttonsStyling : false,
        allowOutsideClick: config.allowOutsideClick !== undefined ? config.allowOutsideClick : true,
        showCancelButton: config.showCancelButton !== undefined ? config.showCancelButton : false,
        showConfirmButton: config.showConfirmButton !== undefined ? config.showConfirmButton : false,
        showCloseButton: config.allowOutsideClick !== undefined ? config.showCloseButton : false,
        reverseButtons: config.reverseButtons !== undefined ? config.reverseButtons : false
    }
    return swal.fire(option);
  }
}
